import React, { PropsWithChildren } from 'react';
import { noop } from 'lodash';
import { ButtonWithIcon } from '../buttons/button-with-icon/ButtonWithIcon';
import { WindowBody } from './partials/WindowBody';
import { WindowFooter } from './partials/WindowFooter';
import { WindowHeader } from './partials/WindowHeader';

export const StepsWindowStep = ({
    onForward = noop, onBack = noop, onClose = noop,
    children, title, backButtonText, forwardButtonText, forwardDisabled
}: StepProps) => {
    return (
        <>
            <WindowHeader previous={onBack} onClose={onClose}>
                {title}
            </WindowHeader>

            <WindowBody disableScroll>
                {children}
            </WindowBody>

            <WindowFooter>
                <ButtonWithIcon style='outline' icon='general-ui-chevron-left' onClick={onBack}>
                    {backButtonText}
                </ButtonWithIcon>
                <ButtonWithIcon icon='general-ui-chevron-right'
                    position='right' onClick={onForward} disabled={forwardDisabled}>
                    {forwardButtonText}
                </ButtonWithIcon>
            </WindowFooter>
        </>
    );
};

export type StepProps = PropsWithChildren<{

    title?: string;

    onForward?: () => void;
    forwardButtonText: string;
    forwardDisabled?: boolean;

    onBack?: () => void;
    backButtonText: string;

    onClose?: () => void;
}>;